import { Box } from '@chakra-ui/react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router'
import { useUserState } from '~/atoms/UserState'

import { useHotelsPermissions } from './useHotelsPermissions'

export const useHotelsPageContext = () => {
  const { t, i18n } = useTranslation()
  const { pbxId, pbx } = useUserState({ canAutoRefresh: false })
  const { permissions } = useHotelsPermissions()

  return useMemo(
    () => ({
      t,
      locale: i18n.resolvedLanguage ?? i18n.language,
      permissions,
      pbxId,
      pbxUuid: pbx?.uuid,
    }),
    [i18n.language, i18n.resolvedLanguage, permissions, pbx?.uuid, pbxId, t],
  )
}

interface HotelsSubNavLinkProps {
  to: string
  label: string
  end?: boolean
}

export const HotelsSubNavLink = ({
  to,
  label,
  end = false,
}: HotelsSubNavLinkProps) => {
  return (
    <NavLink to={to} end={end}>
      {({ isActive }) => (
        <Box
          as="span"
          display="inline-flex"
          px={4}
          py={1.5}
          borderRadius="md"
          fontSize="sm"
          fontWeight={isActive ? 'semibold' : 'medium'}
          bg={isActive ? 'bg.emphasized' : 'transparent'}
          color={isActive ? 'fg.default' : 'fg.muted'}
          transition="background-color 0.15s ease"
          _hover={{
            bg: isActive ? 'bg.emphasized' : 'bg.subtle',
            color: 'fg.default',
          }}
        >
          {label}
        </Box>
      )}
    </NavLink>
  )
}
